import { Box, Toolbar } from '@mui/material';
import { PROMO_MARQUEE_HEIGHT_PX } from './headerConstants';

/** Rezervira prostor ispod fiksnog AppBar-a (navigacija + promo traka). */
export default function AppBarSpacer() {
    return (
        <>
            <Toolbar />
            <Box sx={{ height: PROMO_MARQUEE_HEIGHT_PX, flexShrink: 0 }} aria-hidden />
        </>
    );
}
